import { EFlatTourBookingActionTypes } from '../../actions/flatTourBooking';
import { IFlatTourBookingSchedule } from '../../types/flatTourBooking';
import { TReduxActions } from '../../types/redux';

const initialState = null;

export const flatTourBookingScheduleReducer = (
  state: IFlatTourBookingSchedule | null = initialState,
  action: TReduxActions,
): IFlatTourBookingSchedule | null => {
  switch (action.type) {
    case EFlatTourBookingActionTypes.SetScheduleData:
      return action.payload;
    default:
      return state;
  }
};
